// extracted by mini-css-extract-plugin
export default {"Box":"TableOfContentsPanel-module__Box__R_eoruK","NavList":"TableOfContentsPanel-module__NavList__YnX5AKz"};